import React, { useState } from 'react';

import { 
  CharacterSheetInterface,
} from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import FlexBox from '@components/layout/FlexBox';
import CharacterDMCustomizations from '../customizations/CharacterDMCustomizations';

interface Props {
  char: CharacterSheetInterface;
  disabled: boolean;
  onChange: () => void;
}

export default function CharacterDefensesButton({ 
  char,
  disabled,
}: Props) {
  const [open, setOpen] = useState(false);

  const renderDefensesInput = () => {
    return (
      <FlexBox direction="column">
        <FlexBox className="header centered">
          Defenses
        </FlexBox>
        <CharacterDMCustomizations char={char} />
      </FlexBox>
    );
  }

  return (
    <FlexBox direction="row">
      <FlexBox
        className={`centered header ${ disabled ? "" : "clickable"}`}
        onClick={() => {
          if (!disabled) {
            setOpen(true);
          }
        }}>
        Defenses
      </FlexBox>
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
        }}>
        { open && renderDefensesInput() }
      </ModalOrDrawer>
    </FlexBox>
  );
}
